import Image from 'next/image';
import { useRef } from 'react';
import { CategoryGridGeneralItemSection } from './styled';
import {
  createRippleEffectRelative,
  removeDefaultParams,
} from '../../../Utils/helper';
import { clickCardEvent } from '../../../Utils/StoreHomePageUtils';
import Link from 'next/link';
import { useRouter } from 'next/router';

export default function CategoryGridGeneralItem(props) {
  const { data, isForJoyfulPage } = props;
  const categoryImageGeneralItem = useRef();
  const router = useRouter();

  return (
    <CategoryGridGeneralItemSection isForJoyfulPage={isForJoyfulPage}>
      <div className="sectionTopImage">
        <Image
          src={data.generalItemBgImage}
          alt={data.itemType}
          fill
          priority={true}
          loading={'eager'}
          sizes="100vw"
        />
      </div>
      <div className="grid">
        {data?.items.map((category, index) => (
          <Link
            href={{
              pathname: category?.deeplinkValue,
              query: removeDefaultParams(router.query),
            }}
            passHref
            key={index}
            locale={false}
            legacyBehavior
          >
            <div
              key={index}
              ref={categoryImageGeneralItem}
              onClick={(event) => {
                createRippleEffectRelative(
                  event,
                  categoryImageGeneralItem.current,
                );
                clickCardEvent(category, data);
              }}
            >
              <Image
                className="image"
                src={category.icon}
                alt={category?.icon || ''}
                height={156}
                width={250}
                quality={90}
                priority={false}
                loading={'lazy'}
                sizes="100vw"
                style={{
                  maxWidth: '100%',
                  height: 'auto',
                }}
              />
            </div>
          </Link>
        ))}
      </div>
    </CategoryGridGeneralItemSection>
  );
}
